import { PERSIST, TOKEN } from '../constants/ConfigConst';

export const baseIp = 'https://onedu.app:3000'; // Dominio
// export const baseIp = 'http://localhost:3000'; // LOCAL
// export const baseIp = 'http://167.99.227.200:3000'; // xServer

// export const baseIp = 'http://192.168.182.92:3000'; // Samsung
// export const baseIp = 'http://192.168.0.198:3000'; // MAC - MOBILE
// export const baseIp = 'http://192.168.0.102:3000'; // MAC

export const baseUrl = `${baseIp}/api/v1`;

export const token = ({ isFormData = false, isToken = true }) => {
  const token = localStorage.getItem(TOKEN);
  const headers = {
    'Content-Type': 'application/json',
  };
  if (isToken) headers['Authorization'] = `Bearer ${token}`;
  if (isFormData) headers['Content-Type'] = 'multipart/form-data';
  return headers;
};
//
export const isTokenValid = (res) => {
  if (res.status === 401) {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(PERSIST);
    setTimeout(() => {
      window.location.replace(`${baseIp}`);
    }, 1000);
  }
};
